import React, { FC, useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import {
  getOldAndNewNicFromGivenNic,
  nicFormatFormat,
} from '../../../utils/utilFunctions'

export interface NicInputComponentProps {
  value: string
  isDisabled: boolean
  onChange: any
  errors: any
  newNic: boolean
  incidentDate?: Date
}

const NicInputComponent: FC<NicInputComponentProps> = ({
  value,
  isDisabled,
  onChange,
  errors,
  newNic,
  incidentDate = new Date(),
}) => {
  const [nicValue, setNicValue] = useState(value)

  useEffect(() => {
    setNicValue(value)
  }, [newNic, value])

  return (
    <>
      <Form.Control
        isInvalid={!!errors.nicError}
        maxLength={newNic ? 12 : 10}
        disabled={isDisabled}
        type="text"
        placeholder="Enter NIC Number"
        onBlur={async (e) => {
          const inputValue = e.target.value.trim()

          if (!inputValue) {
            // User cleared the NIC field
            onChange({ cleared: true })
            return
          }

          const identity = await getOldAndNewNicFromGivenNic(
            incidentDate,
            inputValue,
            newNic ? 'N' : 'O'
          )
          onChange(identity)
        }}
        onChange={(e) => {
          let nicNumber = ''
          const input = e.target.value

          if (newNic) {
            nicNumber = nicFormatFormat(input)
          } else {
            nicNumber = input.length < 10 ? nicFormatFormat(input) : input
          }

          setNicValue(nicNumber)
        }}
        value={nicValue}
      />
      <Form.Control.Feedback type="invalid">
        {errors.nicError}
      </Form.Control.Feedback>
    </>
  )
}
export default NicInputComponent
